export const groupValuesByKey = (array) => {
  return array.reduce((out, el) => {
    Object.entries(el).forEach(([key, val]) => {
      if (out[key]) {
        if (out[key].includes(val)) {
          return;
        }
        out[key].push(val);
      } else {
        out[key] = [val];
      }
    });

    return out;
  }, {});
};
